/** The heart, as pixels.
 *
 *  A grid of characters rather than an SVG path, because pixel art edited as a
 *  path is pixel art nobody will ever edit -- you can see the shape in the
 *  source and move a square by changing a character. One <rect> per filled
 *  cell, 45 of them, which is nothing to render once on a login screen.
 *
 *  `shape-rendering: crispEdges` is the whole point: antialiasing a Minecraft
 *  heart gives you a smooth heart, which is a different thing.
 */
const O = "#4a0d0d";   // outline
const R = "#d33b3b";   // the red
const S = "#ff7b7b";   // the shine Minecraft puts in the upper-left bump

export const HEART_GRID = [
  ".oo...oo.",
  "osso.o**o",
  "os**o***o",
  "o*******o",
  ".o*****o.",
  "..o***o..",
  "...o*o...",
  "....o....",
] as const;

const PIXEL: Record<string, string> = { o: O, "*": R, s: S };

export function PixelHeart({ className }: { className?: string } = {}) {
  const w = HEART_GRID[0].length;
  const h = HEART_GRID.length;
  return (
    <svg
      className={["pixelheart", "beat", className].filter(Boolean).join(" ")}
      viewBox={`0 0 ${w} ${h}`}
      shapeRendering="crispEdges"
      role="img"
      aria-label="a heart"
    >
      {HEART_GRID.flatMap((row, y) =>
        [...row].map((c, x) =>
          PIXEL[c] ? (
            <rect key={`${x}-${y}`} x={x} y={y} width="1" height="1" fill={PIXEL[c]} />
          ) : null,
        ),
      )}
    </svg>
  );
}
